import { ApiClient, TokenAdd } from "@/services/apiClient/ApiClient";
import { Currency_Schema } from "@/services/currencies/currenciesSchema";
import { type Currency } from "@/services/currencies/currenciesTypes";

let getAllRequestCache: Promise<Currency[]> | undefined = undefined; // Let's cache API request/response = we load currencies only once pre session.
export const getAllCurrencies = async (): Promise<Currency[]> => {
  if (getAllRequestCache === undefined) {
    getAllRequestCache = ApiClient.getPublic("api-public/currency", {}, TokenAdd.Never).then((response) => Currency_Schema.array().parse(response.data));
  }
  return getAllRequestCache;
};

export const getCurrencyById = async (id: number): Promise<Currency> =>
  getAllCurrencies().then((currencies: Currency[]) => {
    const found = currencies.find((currency) => currency.id === id);
    if (!found) {
      throw new Error("DEV: Currency with id " + id + " not found.");
    }
    return found;
  });
